import styled from 'styled-components';
import { labelStyle } from 'styles/base-classes';
import { AnnotationDetails } from 'components/Annotations/Annotation/Annotation.style';

export const ButtonWrapper = styled.div`
  align-self: center;
  flex: 0 0 auto;
  padding: 0.25em;
  margin-left: 1em;
`;

export const StyledListItem = styled.li`
  display: block;
  padding: 0.5em 0.5em 1em;
  border-left: 1px solid ${({ theme }) => theme.base.Mystic};
  border-right: 1px solid ${({ theme }) => theme.base.Mystic};
  border-bottom: 1px solid ${({ theme }) => theme.base.Mystic};
  background: white;
`;

export const Row = styled.div`
  flex: 1 1 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledAnnotationDetails = styled(AnnotationDetails)`
  display: flex;
  flex-flow: column;
  margin-left: 2.5em;
`;

export const Label = styled.label`
  ${labelStyle};
  margin-top: 2em;
`;

export const Text = styled.p`
  margin: 0.25em 0;
  font-size: 0.8125em;
`;

export const TextInput = styled.input`
  margin: 0.25em 0.5em 0.25em 0;
  padding: 0.75em;
  font-size: 0.8125em;
  color: ${({ theme }) => theme.base.PastelBlue};
  border: none;
  background-color: ${({ theme }) => theme.base.Smoke};
  outline: none;

  &::placeholder {
    color: ${({ theme }) => theme.base.PastelBlue};
  }
`;

export const Textarea = styled.textarea`
  min-height: 9em;
  margin: 0.25em 0.5em 0.25em 0;
  padding: 0.75em;
  font-size: 0.8125em;
  color: ${({ theme }) => theme.base.PastelBlue};
  border: none;
  background-color: ${({ theme }) => theme.base.Smoke};
  outline: none;
  resize: none;

  &::placeholder {
    color: ${({ theme }) => theme.base.PastelBlue};
  }
`;

export const DateAndGroup = styled.label`
  flex: 1 1 100%;
  font-size: 0.8125em;
  font-weight: 700;
`;



// WEBPACK FOOTER //
// ./src/components/Annotations/AddAnnotation/AddAnnotation.style.js